import React from "react";
import { Pencil, Trash2, Eye, EyeOff, Languages, Loader2 } from "lucide-react";

function countTranslations(a) {
  return [a.title, a.title_bg, a.title_es].filter(Boolean).length;
}

export default function ArticleRow({ article, isDark, translating, onTranslate, onTogglePublish, onEdit, onDelete }) {
  const a = article;
  return (
    <div
      className={`flex items-center justify-between p-3 rounded-xl border ${
        isDark ? "bg-gray-700/30 border-gray-600" : "bg-white border-gray-100"
      }`}
      data-testid={`article-row-${a.slug}`}
    >
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-0.5">
          <span className={`text-sm font-medium truncate ${isDark ? "text-white" : "text-[#1A1A2E]"}`}>
            {a.title_bg || a.title}
          </span>
          <span
            className={`text-[10px] px-1.5 py-0.5 rounded-full ${
              a.published ? "bg-[#10B981]/10 text-[#10B981]" : "bg-gray-100 text-gray-400"
            }`}
          >
            {a.published ? "Published" : "Draft"}
          </span>
          <span className="text-[9px] px-1 py-0.5 rounded bg-blue-50 text-blue-500 font-medium">
            {countTranslations(a)}/3 langs
          </span>
        </div>
        <div className={`text-[10px] flex items-center gap-2 ${isDark ? "text-gray-500" : "text-gray-400"}`}>
          <span>/{a.slug}</span>
          <span>{a.category}</span>
          <span>{a.views || 0} views</span>
        </div>
      </div>
      <div className="flex items-center gap-1 ml-3">
        <button
          onClick={() => onTranslate(a.id)}
          disabled={translating === a.id}
          className={`p-1.5 rounded-lg transition-colors ${isDark ? "hover:bg-gray-600" : "hover:bg-gray-100"}`}
          title="Auto-translate to EN + ES"
          data-testid={`translate-article-${a.slug}`}
        >
          {translating === a.id
            ? <Loader2 className="w-3.5 h-3.5 text-[#6366F1] animate-spin" />
            : <Languages className="w-3.5 h-3.5 text-[#6366F1]" />}
        </button>
        <button
          onClick={() => onTogglePublish(a)}
          className={`p-1.5 rounded-lg transition-colors ${isDark ? "hover:bg-gray-600" : "hover:bg-gray-100"}`}
          title={a.published ? "Unpublish" : "Publish"}
        >
          {a.published
            ? <EyeOff className="w-3.5 h-3.5 text-gray-400" />
            : <Eye className="w-3.5 h-3.5 text-[#10B981]" />}
        </button>
        <button
          onClick={() => onEdit(a)}
          className={`p-1.5 rounded-lg transition-colors ${isDark ? "hover:bg-gray-600" : "hover:bg-gray-100"}`}
        >
          <Pencil className="w-3.5 h-3.5 text-[#0EA5E9]" />
        </button>
        <button
          onClick={() => onDelete(a.id)}
          className={`p-1.5 rounded-lg transition-colors ${isDark ? "hover:bg-gray-600" : "hover:bg-gray-100"}`}
        >
          <Trash2 className="w-3.5 h-3.5 text-[#EF4444]" />
        </button>
      </div>
    </div>
  );
}
